import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { CMAData, CMASummaryFilters } from 'components/CMASummary/types';

import { ViewFilters as ViewFiltersType } from './types';
import { CommunityContract } from '../../types/contracts';

type CommunityViewContent = {
  contentRef: any;
  viewId: number;
  view: any;
  viewFilters?: ViewFiltersType | CMASummaryFilters;
  filtersModified: boolean;
  communityId: number;
  community: any;
  competitorId: number | undefined;
  competitors: any[];
  isCompetitorsFetched: boolean;
  apartmentTypes: any[];
  preview: boolean;
  CMASummaryData?: CMAData;
  mostCommonCommunityContract?: CommunityContract;
  setCMASummaryData?: (cma: CMAData) => void;
  setView: (object: any) => void;
  showViewModal: string;
  handleDownloadCSV?: () => void;
  isViewCMA: boolean;
  isViewSalesBattlecard: boolean;
  setShowViewModal: (modal: string) => void;
  viewRefetch: () => void;
  setViewFilters: (value: any) => void;
  setCommunityId: (value: number) => void;
  setHandleDownloadCSV?: Dispatch<SetStateAction<() => void>>;
  triggerExpandAllRef: React.MutableRefObject<() => void>;
  triggerCollapseAllRef: React.MutableRefObject<() => void>;
};

export const CommunityViewContext = createContext<CommunityViewContent>({
  contentRef: undefined,
  viewId: 0,
  view: undefined,
  viewFilters: undefined,
  filtersModified: false,
  communityId: 0,
  community: undefined,
  competitorId: undefined,
  competitors: [],
  isCompetitorsFetched: false,
  apartmentTypes: [],
  preview: false,
  showViewModal: '',
  isViewCMA: false,
  isViewSalesBattlecard: false,
  handleDownloadCSV: () => {
    // Do Nothing
  },
  setHandleDownloadCSV: () => {
    // Do Nothing
  },
  setView: (object: any) => {
    // Do Nothing
  },
  setShowViewModal: () => {
    // Do Nothing
  },
  viewRefetch: () => {
    // Do Nothing
  },
  setViewFilters: (value: any) => {
    // Do nothing
  },
  setCommunityId: (value: any) => {
    // Do nothing
  },
  setCMASummaryData: (value: any) => {
    // Do nothing
  },
  triggerExpandAllRef: {
    current: () => {
      // Do Nothing
    },
  },
  triggerCollapseAllRef: {
    current: () => {
      // Do Nothing
    },
  },
});

export const useCommunityViewContext = () => useContext(CommunityViewContext);
